export default __webpack_public_path__ + "static/media/odnoklassniki_ico.b5b60532.svg";